module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame 4108@2x(4).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame%204108%402x(4).png
// module id = ZyNm
// module chunks = 93